import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import appInitialization from 'modules/appInit';
import popoutReducer from 'modules/layout/sidePopout/redux/slice';
import toastContainerReducer from 'modules/layout/toastContainer/redux/slice';
import loginReducer from 'modules/landingPage/components/login/redux/slice';
import inboxReducer from 'modules/inboxPage/redux/slice';
import profileReducer from 'modules/profilePage/redux/slice';
import contractsReducer from 'modules/contractsPage/redux/slice';
import newRequestReducer from 'modules/newRequestPage/redux/slice';
import contactReducer from 'modules/contactPage/redux/slice';
import billsReducer from 'modules/billsPage/redux/slice';
import documentationReducer from 'modules/documentationPage/redux/slice';
import registerReducer from 'modules/registerPage/redux/slice';
import locationCodesReducer from 'modules/hooks/codesHooks/redux/locationCodes/slice';
import entityBusinessReducer from 'modules/hooks/codesHooks/redux/legalEntityCodes/redux/slice';
import leasingCalculatorCodesReducer from 'modules/hooks/codesHooks/redux/leasingCalculatorCodes/slice';
import leasingOffersReducer from 'modules/leasingOffersPage/redux/slice';
import leasingCalculatorReducer from 'modules/leasingCalculator/redux/slice';
import searchReducer from 'modules/ui/headerSearch/redux/slice';
import leasingOfferDetailsReducer from 'modules/leasingOfferOverviewPage/redux/slice';
import contractDetailsReducer from 'modules/contractsOverviewPage/redux/slice';
import accessibilityReducer from "../modules/ui/accessability/redux/slice";

export const rootReducer = {
  // TODO add reducers here
  // component helpers
  appInfo: appInitialization,
  popout: popoutReducer,
  toastContainer: toastContainerReducer,
  accessibility: accessibilityReducer,
  // data store
  login: loginReducer,
  inbox: inboxReducer,
  profile: profileReducer,
  contracts: contractsReducer,
  newRequest: newRequestReducer,
  contact: contactReducer,
  bills: billsReducer,
  documentation: documentationReducer,
  register: registerReducer,
  locationCodes: locationCodesReducer,
  entityAndBusiness: entityBusinessReducer,
  leasingOffers: leasingOffersReducer,
  leasingCalculatorCodes: leasingCalculatorCodesReducer,
  leasingCalculator: leasingCalculatorReducer,
  search: searchReducer,
  leasingOfferDetails: leasingOfferDetailsReducer,
  contractDetails: contractDetailsReducer,
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
